import React from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styles from './CustomLink.css';

const cx = classnames.bind(styles);

function CustomLink(props) {
    const {className, onClick, to, target, children, replace, withDefaultClassName, style} = props;
    const classes = cx({
        link: withDefaultClassName,
        [className]: Boolean(className)
    });
    const handleClick = e => {
        onClick?.(e);
    };

    if (target === '_blank') {
        return (
            <a
                className={classes}
                onClick={handleClick}
                href={to}
                target='_blank'
                rel='noopener noreferrer'
                style={style}
            >
                {children}
            </a>
        )
    }

    if (target === 'custom') {
        return (
            <a
                className={classes}
                onClick={handleClick}
                href={to}
                rel='noopener noreferrer'
                style={style}
            >
                {children}
            </a>
        )
    }

    return (
        <Link
            className={classes}
            onClick={handleClick}
            to={to}
            replace={replace}
            style={style}
        >
            {children}
        </Link>
    );
}

CustomLink.defaultProps = {
    onClick: null,
    className: '',
    target: '',
    replace: false,
    withDefaultClassName: true,
    style: {}
};

CustomLink.propTypes = {
    to: PropTypes.string.isRequired,
    children: PropTypes.any.isRequired,
    target: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    replace: PropTypes.bool,
    withDefaultClassName: PropTypes.bool,
    style: PropTypes.object
};

export default CustomLink;
